/**
 * @see https://stackoverflow.com/a/43606883
 */
export const roundToIncrement = (value, increment = 0.01, fn = 'round') => {
	const interval = 1 / increment;

	return Math[fn](value * interval) / interval;
};
